export default __webpack_public_path__ + "static/media/home-bg-overlay.865dcb66.png";